export const ROLL_CONVENTION_ENUM = {
  PRECEDING: 'PRECEDING',
  FOLLOWING: 'FOLLOWING',
  MODIFIED_FOLLOWING: 'MODIFIED_FOLLOWING',
  NO_ROLL: 'NO_ROLL',
};

export const ROLL_CONVENTION_OPTIONS = [
  { id: ROLL_CONVENTION_ENUM.FOLLOWING, displayValue: 'Following' },
  {
    id: ROLL_CONVENTION_ENUM.MODIFIED_FOLLOWING,
    displayValue: 'Modified Following',
  },
];
